import React, { useEffect, useState } from "react";
import { Modal, DatePicker, Flex, Spin, message } from "antd";
import { CiCirclePlus } from "react-icons/ci";
import FilterIcon from "../../../../../Assets/Images/Svg/FilterIcon.svg";
import nodatafound from "../../../../../Assets/Icons/NoDataCard2.svg";
import AddDevices from "./addDevices";
import MappedDevicesTable from "./mappedDevicesTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchPatMappedRpmDevList } from "../../../../../Redux/actions/rpmActions";
import PatientService from "../../../../../Services/PatientService";
import {
  clearPatientFilter,
  fetchPatients,
  fetchPatientsCount,
} from "../../../../../Redux/actions/patientActions";
import { FaFilter } from "react-icons/fa";

function Devices({
  data,
  currPageView,
  handleCancel,
  handleNext,
  handlePrevious,
}) {
  const [deviceModal, setDeviceModal] = useState(false);
  const [currLocalMappedDev, setCurrLocalMappedDev] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const { registrationPayload } = useSelector((state) => state.patients);
  const { isLoading, mappedDevicesList } = useSelector((state) => state.rpm);
  const { selectedEditPatient, patientFilter } = useSelector(
    (state) => state.patients
  );
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  // useEffect(() => {
  //     const payload = {
  //         status: 1
  //     }
  //     dispatch(fetchPatMappedRpmDevList(payload));
  // }, [])

  useEffect(() => {
    if (selectedEditPatient?.patientDevicesList) {
      setCurrLocalMappedDev(selectedEditPatient?.patientDevicesList);
    }
  }, [selectedEditPatient]);

  const handleNewDeviceMod = () => {
    setDeviceModal(!deviceModal);
  };

  const handlePatientFinalSave = async () => {
    if (!registrationPayload) {
      message.error("Please fill data in all tabs.");
      return;
    }

    setLoader(true);
    const payload = {
      ...registrationPayload,
      patientDevicesList: currLocalMappedDev.map((item) => {
        return {
          ...item,
          modifiedBy: loggedUser?.user?.userId,
        };
      }),
    };

    // Updated patient list fetching payload
    const patPayload = { pageNo: 1 };
    if (loggedUser?.user?.rolecode === "ACCT_ADM") {
      patPayload.account_Id = loggedUser.user.account_Id;
    } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
      patPayload.account_Id = loggedUser.user.account_Id;
      patPayload.clinic_Id = loggedUser.user.clinic_Id;
    }

    if (selectedEditPatient) {
      try {
        await PatientService.EditPatientData(payload);
        message.success("Patient Details updated successfully!!");
        // Update patient list
        dispatch(fetchPatients(patPayload));
        setLoader(false);
        handleCancel();
        if (patientFilter) dispatch(clearPatientFilter(false));
      } catch (e) {
        setLoader(false);
        console.error(e);
      }
    } else {
      try {
        await PatientService.AddPatient(payload);
        message.success("Patient created successfully!!");
        // Update patient list
        // dispatch(fetchPatients(patPayload));
        // dispatch(fetchPatientsCount(patPayload));
        handleCancel();
        setLoader(false);
      } catch (e) {
        setLoader(false);
        console.error(e);
        e && message.error(e.response.data.message);
      }
    }
  };

  const handlSetLocalMappedDevices = (mappingObj) => {
    setCurrLocalMappedDev((prevState) => [...prevState, mappingObj]);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-center py-3 px-6">
          <div className="">
            <h1 className="font-bold text-xl">Devices</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={handleNewDeviceMod}
                className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
              >
                <span className="w-5 h-5">
                  <CiCirclePlus className="w-full text-[#189FAA] h-full" />
                </span>
                <span className="">New</span>
              </button>
            </div>
            <div>
              <button className="w-20 h-9 px-2 flex items-center rounded-md gap-2 bg-brand-primaryColor">
                <span>
                  <FaFilter className="mr-1" />
                </span>
                <span className="text-white"> Filter</span>
              </button>
            </div>
          </div>
        </div>

        <div
          className={`${
            isLoading === false && currLocalMappedDev?.length === 0
              ? "w-full flex justify-center items-center"
              : "overflow-y-scroll h-[23rem] scrollWidth"
          }`}
        >
          {isLoading && currLocalMappedDev?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : currLocalMappedDev?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img src={nodatafound} alt="nodatafound" className="h-32 w-32" />
              <p className="font-medium text-xl">No data found!!</p>
            </div>
          ) : (
            <div>
              <MappedDevicesTable
                data={currLocalMappedDev}
                totalCount={currLocalMappedDev?.length}
              />
            </div>
          )}
        </div>
        <div className="mt-8">
          <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
            <button
              disabled={loader}
              className={`${
                currPageView > 1 ? "block" : "hidden"
              } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
              onClick={handlePrevious}
            >
              Previous
            </button>
            <button
              disabled={loader}
              className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border bg-white border-brand-primaryColor font-semibold custom-button-shadow"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              disabled={loader}
              className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
              onClick={handlePatientFinalSave}
            >
              {selectedEditPatient ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
      <Modal
        title="New Devices"
        footer={[]}
        open={deviceModal}
        onCancel={handleNewDeviceMod}
      >
        <AddDevices
          handleNewDeviceMod={handleNewDeviceMod}
          handlSetLocalMappedDevices={handlSetLocalMappedDevices}
        />
      </Modal>
    </>
  );
}

export default Devices;
